import React from "react";
import Image from "next/image";
import { useAccessibility } from "@/hooks/useAccessibility";
import { useMediaQuery, query } from "@/hooks/useMediaQuery";
import { Container, ImageWrapper, InfoBanner } from "./styles";
import BannerImage from "/public/planos_municipais/banner/images/bg.png";
import { Icon } from "./icon";

export const Banner: React.FC = () => {
  return (
    <Container>
      <ImageWrapper>
        <Image
          fill={true}
          quality={100}
          loading="eager"
          priority={true}
          className="image"
          src={BannerImage.src}
          alt="imagem de criança estudando"
        />
        <Info />
      </ImageWrapper>
    </Container>
  );
};

export const Info = () => {
  const { isMobile } = useMediaQuery(query);
  const { fontSizeIncreased } = useAccessibility();

  return (
    <InfoBanner isMobile={isMobile} isIncrease={fontSizeIncreased}>
      <div className="col-1">
        <Icon />
      </div>
      <div className="col-2">
        <div className="title_wrapper">
          <p className="resizeable-accessibility">PLANOS</p>
        </div>
        <div className="description_wrapper resizeable-accessibility">
          {/* <p>
            Documentos que orientam as ações da Prefeitura para a melhoria da
            qualidade de vida dos cariocas
          </p> */}
        </div>
      </div>
    </InfoBanner>
  );
};